import axios from 'axios'

const RESOURCE_NAME = '/products'

export default {
  getAll (params = '') {
    if (params) {
      let param = params.replace(`/${process.env.VUE_APP_API_ENDPOINT}${RESOURCE_NAME}/g`, '')
      return axios.get(`${RESOURCE_NAME}?${param}`)
    } else {
      return axios.get(RESOURCE_NAME)
    }
  },

  get (id) {
    return axios.get(`${RESOURCE_NAME}/${id}`)
  },

  create (data) {
    return axios.post(RESOURCE_NAME, data)
  },

  update (id, data) {
    return axios.post(`${RESOURCE_NAME}/${id}`, data)
  },

  delete (id) {
    return axios.delete(`${RESOURCE_NAME}/${id}`)
  }
}
